export class GeneralLogScreenFiltersDataModel {
  fromDate: String = '';
  toDate: String = '';
  constructor(options?: {
    fromDate: String,
    toDate: String,
  }) {
    if (options) {
      this.fromDate = options.fromDate;
      this.toDate = options.toDate;
    }
  }
}
